export default __webpack_public_path__ + "static/hero-broker-cal-56522fe7c9e17a0fe5dea04fe919633a.jpg";